import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

// ✅ Definición de la función sin exportación aquí
function LoginPage({ handleLogin }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // ⚠️ Importante: El `alert` debe ser reemplazado por un modal/mensaje de error en un entorno de producción.
  const onSubmit = async () => {
    if (!email || !password) {
      alert("Completa todos los campos");
      return;
    }

    // Llama a la función de login que está en App.js
    await handleLogin(email, password);
    
    // Limpiar campos solo si el login fue exitoso (esto lo maneja App.js normalmente)
    // Para simplificar, lo dejamos aquí, pero el control de éxito es en App.js
    setEmail("");
    setPassword("");
    
    // Redirigir. NOTA: Si handleLogin falla, esta línea se ejecutará igual.
    // Lo ideal es que la redirección esté en App.js DENTRO de la lógica de éxito del login.
    navigate("/");
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "calc(100vh - 120px)",
        backgroundColor: "#f5f5f5",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "400px",
          width: "90%",
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: "30px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          position: "relative",
        }}
      >
        {/* 🔙 Flecha para volver atrás */}
        <FaArrowLeft
          onClick={() => navigate(-1)}
          title="Volver"
          style={{
            position: "absolute",
            top: "15px",
            left: "15px",
            color: "#4B6CB7",
            fontSize: "18px",
            cursor: "pointer",
            transition: "color 0.2s ease",
          }}
          onMouseOver={(e) => (e.target.style.color = "#324b8a")}
          onMouseOut={(e) => (e.target.style.color = "#4B6CB7")}
        />

        <h2
          style={{
            textAlign: "center",
            marginBottom: "20px",
            fontWeight: "600",
            color: "#000",
          }}
        >
          Iniciar Sesión
        </h2>

        <input
          type="email"
          placeholder="Correo"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{
            width: "100%",
            marginBottom: "10px",
            padding: "10px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            outline: "none",
          }}
        />

        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{
            width: "100%",
            marginBottom: "15px",
            padding: "10px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            outline: "none",
          }}
        />

        <button
          onClick={onSubmit}
          style={{
            width: "100%",
            padding: "12px",
            backgroundColor: "#4B6CB7",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Iniciar Sesión
        </button>

        {/* 🔗 Enlace para recuperar contraseña */}
        <p style={{ marginTop: "15px", textAlign: "center" }}>
          <a
            href="/forgot-password"
            style={{
              color: "#f28e8e",
              textDecoration: "none",
              fontWeight: "500",
            }}
            onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
            onMouseOut={(e) => (e.target.style.textDecoration = "none")}
          >
            ¿Olvidaste tu contraseña?
          </a>
        </p>

        <button
          onClick={() => {
            if (window.history.length > 2) {
              navigate(-1);
            } else {
              navigate("/");
            }
          }}
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "10px",
            backgroundColor: "#ccc",
            color: "black",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Cancelar
        </button>
      </div>
    </div>
  );
}

// ✅ Exportación por defecto al final para evitar el error de Webpack/Babel
export default LoginPage;